export default __webpack_public_path__ + "static/media/photo-charte09.d700bd29.png";